import $ from 'jquery';
import '../class/jquery.datetimepicker.full.min';

const datepicker = ($target) => {

		$.datetimepicker.setLocale('cs');

		$target.find('.js-datepicker').each(function() {
			var $input = $(this);

			$input.attr('autocomplete', 'off');

			$input.datetimepicker({
				timepicker:false,
				format:'d.m.Y'
			});
		});

		$target.find('.js-timepicker').each(function() {
			var $input = $(this);

			$input.attr('autocomplete', 'off');

			$input.datetimepicker({
				datepicker:false,
				format:'H:i'
			});
		});

};

exports.init = datepicker;



// WEBPACK FOOTER //
// ./src/js/components/datepicker.js